import * as React from 'react'; // eslint-disable-line
import styled from 'styled-components';

import Thumbnail, { PAGINATION_THUMBNAIL_WIDTH } from './atoms/thumbnail';
import { SPACING } from '../../packages/constants';
import { camelToKebab } from '../../../Scripts/Spotlight/Components/CamelToKebab';
import { PageDataProps } from './preview';

export interface PreviewPaginationProps {
    hasFullscreenOption: boolean;
    isFullscreen: boolean;
    pageData: PageDataProps[];
    showThumbnails: boolean;
    scrollOffset: number;
    onPageSelect: () => void;
}

interface PaginationItemProps {
    showThumbnails?: boolean;
}

interface PaginationProps {
    hasFullscreenOption: boolean;
    isFullscreen: boolean;
}

const Pagination = styled.ul<PaginationProps>`
    box-sizing: border-box;
    height: ${(props) => (props.hasFullscreenOption ? (props.isFullscreen ? '100%' : 'calc(100% - 44px)') : '100%')};
    overflow-y: auto;
    padding: ${(props) =>
        `${SPACING.MEDIUM} ${SPACING.MEDIUM} 0 ${props.hasFullscreenOption ? SPACING.MEDIUM : SPACING.X_SMALL};`};
    width: ${(props) => (props.hasFullscreenOption ? `calc(${PAGINATION_THUMBNAIL_WIDTH} + 48px)` : `258px`)};
`;

const PaginationItem = styled.li<PaginationItemProps>`
    list-style-type: none;
    margin: 0 0 ${(props) => (props.showThumbnails ? SPACING.LARGE : SPACING.X_SMALL)};
    padding: 0;
    width: 100%;
`;

export const PreviewPagination = ({
    hasFullscreenOption,
    isFullscreen,
    pageData,
    showThumbnails,
    scrollOffset,
    onPageSelect,
}: PreviewPaginationProps) => {
    return (
        <Pagination
            hasFullscreenOption={hasFullscreenOption}
            isFullscreen={isFullscreen}
            id={'thumbnail-list'}
            data-test-id={'preview__ul-thumbnail-list'}
        >
            {pageData.map((page: PageDataProps, index: number) => (
                <PaginationItem key={`nav-${page.id}`} showThumbnails={showThumbnails}>
                    <Thumbnail
                        activeClass={'active'}
                        additionalPageNumber={
                            (page.hasOwnProperty('additionalPageNumber') && page.additionalPageNumber) || ''
                        }
                        containerId={'preview__scroll-container'}
                        data-test-id={`preview__pagination-link-${camelToKebab(page.title)}-${index}`}
                        href={`#${page.id}`}
                        imageSrc={page.imageSrc}
                        isAdditionalPage={page.isAdditionalPage}
                        isLoading={page.thumbnailIsLoading}
                        offset={scrollOffset}
                        showThumbnail={showThumbnails}
                        title={page.title}
                        to={page.id}
                        onSetActive={onPageSelect}
                    />
                </PaginationItem>
            ))}
        </Pagination>
    );
};

PreviewPagination.displayName = 'PreviewPagination';
